export const SCREENING_STEP_TYPES = {
  START: 'START',
  SETTINGS: 'SETTINGS',
  FINAL: 'FINAL',
};

export class StepButton {
  constructor(data = {}) {
    this.show = data.show || false;
    this.title = data.title || '';
    this.link = data.link || '';
  }
}

export class DemoTestsButtonLabels {
  constructor(data = {}) {
    this.title = data.title || {};
    this.subtitleBefore = data.subtitleBefore || {};
    this.subtitleAfter = data.subtitleAfter || {};
    this.clickText = data.clickText || {};
  }
}

export class ScreeningCustomStep {
  constructor(data = {}) {
    this._id = data._id || data.id;
    this.step = data.step || SCREENING_STEP_TYPES.START;
    this.workspaceId = data.workspaceId;
    this.screeningId = data.screeningId || null;
    this.testGroupGrouperKey = data.testGroupGrouperKey || null;
    this.title = data.title || '';
    this.subtitle = data.subtitle || '';
    this.button = data.button ? new StepButton(data.button) : null;
    this.showSubmitDialog = data.showSubmitDialog || false;
    this.showSkipDialog = data.showSkipDialog || false;
    this.showDemoTestsButton = data.showDemoTestsButton || false;
    this.demoTestsButtonLabels = data.demoTestsButtonLabels
      ? new DemoTestsButtonLabels(data.demoTestsButtonLabels)
      : null;
    this.deletedAt = data.deletedAt || null;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    // Populated data from backend
    this.screening = data.screening || null;
    this.testGroup = data.testGroup || null;
  }
}
